import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const evaluationFormApi = tokenSlice.injectEndpoints({
  reducerPath: "evaluationForm",
  baseQuery: createBaseQuery(),
  tagTypes: ["EvaluationForm"],
  endpoints(builder) {
    return {
      // GET

      getCompanyInfo: builder.query({
        query: () => ({
          url: `SupplierEvaluation/InitReg`,
          method: "GET",
        }),
        providesTags: ["EvaluationForm"],
      }),


      // POST

    //   postSaveRole: builder.mutation({
    //     query: (data) => ({
    //       url: "Approval/SaveRole",
    //       method: "POST",
    //       body: data,
    //     }),
    //     invalidatesTags: ["Approval"],
    //   }),

   

    //   // DELETE

    //   deleteRole: builder.mutation({
    //     query: (data) => ({
    //       url: 'Approval/DeleteRole',
    //       method: 'DELETE',
    //       body: data
    //     }),
    //     invalidatesTags: ['Approval']
    //   }),

    

    };
  },
});

export const {
  useGetCompanyInfoQuery
} = evaluationFormApi;
export { evaluationFormApi };
